
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-email-finder",
      function () {
        return require("private-next-pages/instagram-email-finder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-email-finder"])
      });
    }
  